import { render, staticRenderFns } from "./TransferRecords.vue?vue&type=template&id=44e0eb84&scoped=true&"
import script from "./TransferRecords.vue?vue&type=script&lang=js&"
export * from "./TransferRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e0eb84",
  null
  
)

export default component.exports